









import { Component, Vue, Prop } from 'vue-property-decorator'
import Candidate from '@/evaluations/entities/candidate'

@Component
export default class CandidateName extends Vue {
  @Prop()
  private candidate!: Candidate
}
